// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Qtk0","colMin":"styles_colMin__1uJsh"};